import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Dropdown = ({
  category,
  categorySubType,
  dropdownList,
  handleChange,
  dropdownHeader
}) => {
  const [isListOpen, setList] = useState(false);
  const [header, setHeader] = useState(dropdownHeader);
  const [showImage, setShowImage] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [rareImage, setRareImage] = useState();
  const [backgroundColor, setBackgroundColor] = useState();
  const [radius, setRadius] = useState("0.5rem");
  const toggleList = () => {
    setList(!isListOpen);
    if(radius === "0.5rem")
      setRadius("0.5rem 0.5rem 0 0")
    else 
      setRadius("0.5rem")
  };
  useEffect(() => {
    setHeader(dropdownHeader);
  }, [dropdownHeader]);

  const changeName = (item) => {
    if (categorySubType === "background") {
      setShowImage(false);
      setShowColor(true)
      setBackgroundColor(item.name)
    } 
    else if (categorySubType === "base image" || categorySubType === "layerchoice") {
      setShowColor(false)
      setShowImage(true);
      setRareImage(item.preview);
    }
    else {
      setShowColor(false)
      setShowImage(false)
    }
      
    if(category === "rarity") {
      if (categorySubType === "main") {
        handleChange("rarity_type", item)
        setHeader(item);
      }
      else if(categorySubType === "background") {
        handleChange("id_of_type", item.id)
        if (item.price)
          setHeader(` - Rank #${item.rank} - ${item.price} AVAX`);
        else
          setHeader(` - Rank #${item.rank}`);
      }
      else {
        handleChange("id_of_type", item.id)
        setHeader(item.name);
      }
    }
    else if(category === "campaign") {
      if (categorySubType === "main") {
        setHeader(item.campaign_name)
        handleChange(item)
      }
      else if (categorySubType === "beneficiary") {
        setHeader(item.beneficiary_name)
        handleChange("beneficiary_id", item.beneficiary_id)
      }
      else if (categorySubType === "artist") {
        setHeader(item.name)
        handleChange(item.id)
      }
      else if (categorySubType === "artPack") {
        setHeader(item.art_pack_name)
        handleChange(item)
      }
      else if (categorySubType === "devCut") {
        setHeader(item)
        handleChange("dev_cut_of_sponsor_distro", item)
      }
      else if (categorySubType === "websiteFont") {
        setHeader(item)
        handleChange("general_font", item)
      }
    }
    else if (category === "backgroundPrice") {
      setHeader(` - Rank #${item.rank}`)
      handleChange("rank", item.rank)
    }
    else if (category === "artist") {
      if (categorySubType === "availability") {
        setHeader(item)
        handleChange("available_for_campaigns", item)
      }
      else if(categorySubType === "layer" || categorySubType === "layerchoice") {
        setHeader(item.name)
        handleChange(item.id)
      }
      else if(categorySubType === "artPack") {
        setHeader(item.art_pack_name)
        handleChange(item)
      }
    }
  };

  return (
    <div>
      <div className="dropdown__wrapper" onClick={toggleList}>
        <div className="dropdown__top" style={{borderRadius: radius}}>
          <div className="dropdown__header">
            <div className="logo-choice-block">
              {showImage && <img src={rareImage} className="header-logo" alt="" />}
              {showColor && (
                <div
                  className="color-box"
                  style={{ backgroundColor: backgroundColor }}
                ></div>
              )}
              <span className="list-name">{header}</span>
            </div>
          </div>
          <div className="chevron-down">
            <FontAwesomeIcon icon="fa-solid fa-chevron-down" size="xl" color="#707070" />
          </div>
        </div>
        <div
          className={`dropdown__bottom ${isListOpen ? "d-block" : "d-none"}`}
        >
          <ul className="dropdown__lists">
            {dropdownList.map((item, index) => (
              <li
                key={index}
                className="dropdown__list"
                onClick={() => changeName(item)}
              >
                <div className="list-choice-block">
                  {categorySubType === "background" ? (
                    <div
                      className="color-box"
                      style={{ backgroundColor: item.name }}
                    ></div>
                  ) : 
                  categorySubType === "base image" || categorySubType === "layerchoice" ? (
                    <img src={item.preview} className="list-image" alt="" />
                  ) :
                  ""
                }
                  <span className="list-name" style={{textTransform: 'capitalize'}}>{category === "campaign" && categorySubType === "main" ? item.campaign_name : category === "campaign" && categorySubType === "beneficiary" ? item.beneficiary_name : categorySubType === "artPack" ? item.art_pack_name : categorySubType === "main" || categorySubType === "availability" || categorySubType === "devCut" || categorySubType === "websiteFont" ? item : category === "backgroundPrice" ? ` - Rank #${item.rank}` : categorySubType === "background" ? item.price ? ` - Rank #${item.rank} - ${item.price} AVAX` : ` - Rank #${item.rank}` : item.name}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
